import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { rusPassportCode } from '../../../../constants/constants';
import { FieldWrapper } from '../../../FieldWrapper';
import { TrimmedInput } from '../../../TrimmedInput';
export const DocumentIssuerUnitCodeField = ({ value, documentType, onValueChange, validationInfo, labelClassName, 'data-tid': dataTid, disabled, }) => {
    useEffect(() => {
        if (documentType === rusPassportCode) {
            const documentNumber = value
                .replace(/\D/g, '')
                .substring(0, 6)
                .replace(/^(\d{3})(\d{3})$/, '$1-$2');
            onValueChange(documentNumber);
        }
    }, [documentType]);
    const mask = documentType === rusPassportCode ? '999-999' : undefined;
    return (_jsx(FieldWrapper, { label: "\u041A\u043E\u0434 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F", labelClassName: labelClassName, children: _jsx(TrimmedInput, { width: 120, mask: mask, value: value, onValueChange: onValueChange, validationInfo: validationInfo, "data-tid": dataTid, disabled: disabled }) }));
};
